import styles from './style.module.css';
import { useNavigate } from 'react-router-dom';

interface IButtonBack {
  title?: string;
}

export function ButtonBack({ title }: IButtonBack) {
  const navigate = useNavigate();

  function handleBack() {
    navigate(-1);
  }

  return (
    <>
      <div className="d-flex align-items-center">
        <button className={`${styles.backButton} me-3`} onClick={handleBack}>
          <i className="material-icons-outlined color-text">west</i>
        </button>
        <span className="fs-5">{title}</span>
      </div>
    </>
  );
}
